import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../../services/academy/studentsServices';
import reportServices from '../../../../services/reportServices';

import compare from '../../../../functions/compare';
import convertAge from '../../../../functions/convertAge';

import ClassStudentsCardItem from './ClassStudentsCardItem';
import PopupNewStudent from './PopupNewStudent';
import PopupNewPayment from '../../Student/StudentPaymentsCard/PopupNewPayment';
import PopupStudentsReports from '../../Students/PopupStudentsReports';
import ActivityIndicator from '../../../../components/ActivityIndicator';
import { FaUsers } from 'react-icons/fa';

export default function ClassStudentsCard(props) {
    const [popupNewStudentVisible, setPopupNewStudentVisible] = useState(false);
    const [popupNewPaymentVisible, setPopupNewPaymentVisible] = useState(false);
    const [popupNewPaymentData, setPopupNewPaymentData] = useState(false);
    const [popupStudentsReportsVisible, setPopupStudentsReportsVisible] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const [students, setStudents] = useState([]);
    const [fetching, setFetching] = useState(true);
    const minSize = 6;

    useEffect(() => {
        if (props.classId && props.classType && props.classAgeGroup)
            readStudents();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.classId, props.classType, props.classAgeGroup]);

    async function readStudents() {
        const response = await studentsServices.getStudents();
        setFetching(false);
        if (response.status === 200) {
            setStudents(
                response.data
                    .filter((item) => item.turma == null || item.turma.id !== props.classId)
                    .filter((item) =>
                        (props.classType === "Mista" || item.genero[0] === props.classType[0])
                        && convertAge(item.data_nascimento) <= Number(props.classAgeGroup.substring(4))
                        // && convertAgeGroupInAgesArray(props.classAgeGroup).includes(convertAge(item.data_nascimento))
                    )
                    .sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`))
            );
        } else
            alert("Erro ao ler alunos, tente novamente!");
    }

    function deleteItemFromList(index, array = students, setArray = setStudents) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    async function generateReport(fields = null) {
        console.log(fields);
        try {
            await reportServices.generateReportStudents(props.classStudents, `RELATÓRIO DE ALUNOS DA TURMA "${props.className}"`, fields);
            setPopupStudentsReportsVisible(false);
        } catch (err) {
            alert(err.message);
        }
    }

    return (
        <div className='class-page-card' id='card-students'>
            <div className='class-card-students-header'>
                <div>
                    <h4><b><FaUsers />Alunos</b></h4>
                </div>
                <span className={'vacancies' + (props.vacancies ? '' : ' none')}>
                    {
                        props.vacancies ?
                            props.vacancies + ' vagas'
                            : 'Não há vagas'
                    }
                </span>

            </div>

            {
                props.vacancies ?
                    <>
                        <button className='new-student' onClick={() => setPopupNewStudentVisible(true)}>Inscrever aluno</button>
                        <PopupNewStudent
                            visibility={popupNewStudentVisible}
                            setVisibility={setPopupNewStudentVisible}
                            students={students}
                            classId={props.classId}
                            classType={props.classType}
                            onUpdate={props.onUpdate}
                            onDelete={deleteItemFromList}
                        />
                    </>
                    : []
            }

            {
                props.coachMode ?
                    [] :
                    <>
                        <button
                            className="button reports"
                            title="Gerar relatório"
                            onClick={() => setPopupStudentsReportsVisible(true)}
                        >
                            Gerar relatório
                        </button>
                        <PopupStudentsReports
                            visibility={popupStudentsReportsVisible}
                            setVisibility={setPopupStudentsReportsVisible}
                            generateReport={generateReport}
                        />
                    </>
            }

            {
                !fetching ?
                    <>
                        <div className='class-card-students-list-infos'>
                            <p><b>Inscritos</b></p>
                            <p>{props.classStudents ? props.classStudents.length : 0} alunos</p>
                        </div>
                        {
                            props.classStudents && props.classStudents.length ?
                                <>
                                    <ul className='class-card-students-list'>
                                        {
                                            props.classStudents.slice(0, showAll ? undefined : minSize).map((item, index) =>
                                                <ClassStudentsCardItem
                                                    coachMode={props.coachMode}
                                                    key={item.id}
                                                    index={index}
                                                    id={item.id}
                                                    photo={item.foto}
                                                    name={`${item.nome} ${item.sobrenome}`}
                                                    showPopup={(data) => {
                                                        setPopupNewPaymentData(data);
                                                        setPopupNewPaymentVisible(true);
                                                    }}
                                                    onDelete={(index) => {
                                                        readStudents();
                                                        props.onDelete(index);
                                                        props.onUpdate();
                                                    }}
                                                />
                                            )
                                        }
                                    </ul>
                                    {
                                        props.classStudents.length > minSize ?
                                            <button className='show-all' type="button" onClick={() => setShowAll(!showAll)}>
                                                {
                                                    showAll ?
                                                        "Ocultar"
                                                        : "Exibir tudo"
                                                }
                                            </button>
                                            : []
                                    }
                                </>
                                : []
                        }

                        {
                            props.coachMode ?
                                [] :
                                <PopupNewPayment
                                    showUserInfos
                                    data={popupNewPaymentData}
                                    visibility={popupNewPaymentVisible}
                                    setVisibility={setPopupNewPaymentVisible}
                                />
                        }
                    </>
                    : <ActivityIndicator />
            }
        </div>
    )
}